import * as S from './index.style'
import { DadosMuros, ValidacaoDadosMuros } from 'models/Viabilidade/DadosMuros'
import { ElementType, useState } from 'react'
import { InputBaseComponentProps, MenuItem, TextField } from '@material-ui/core'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { TipoMuroEnum } from 'models/Viabilidade/Enum/TipoMuroEnum'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import { ajudaMuroExterno } from 'helpers/Constantes/Mensagens'
import { FieldInfo } from 'components/FieldInfo'

const Muros: React.FC<{
  tipoProjeto: string
  dadosMuros: DadosMuros
  dadosMurosHandler: (novoValor: DadosMuros) => void
}> = ({ tipoProjeto, dadosMuros, dadosMurosHandler }) => {
  const [valores, setValores] = useState(dadosMuros)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosMuros())

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = { ...valores, [event.target.name]: event.target.value }
    setValores(state)
    dadosMurosHandler(state)
  }

  const validarTipoMuroExterno = () => {
    const erroTipoMuroExterno = mensagensErro.validarTipoMuroPreenchido(dadosMuros.tipoMuroExterno)
    const validador = new ValidacaoDadosMuros(erroTipoMuroExterno, mensagensErro.perimetroExterno, mensagensErro.tipoMuroInterno)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarPerimetroExterno = () => {
    const erroPerimetroExterno = mensagensErro.validarPerimetroPreenchidoValorDiferenteZero(dadosMuros.perimetroExterno, dadosMuros.tipoMuroExterno)
    const validador = new ValidacaoDadosMuros(mensagensErro.tipoMuroExterno, erroPerimetroExterno, mensagensErro.tipoMuroInterno)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarTipoMuroInterno = () => {
    const erroTipoMuroInterno = mensagensErro.validarTipoMuroPreenchido(dadosMuros.tipoMuroInterno as string)
    const validador = new ValidacaoDadosMuros(mensagensErro.tipoMuroExterno, mensagensErro.perimetroExterno, erroTipoMuroInterno)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosMuros) => {
    const state = { ...valores } as DadosMuros
    state.valido = validador.validarTodosCampos(state, tipoProjeto)
    setValores(state)
    dadosMurosHandler(state)
  }

  return (
    <S.Wrapper data-cy="sessaoMuros">
      {tipoProjeto !== TipoProjetoEnum.LoteamentoAberto && (
        <S.Wrapper data-cy="sessaoMuroExterno">
          <S.NomeSubSessao>
            MURO EXTERNO
            <FieldInfo title={ajudaMuroExterno} dataCy="fieldInfoMuroExterno" />
          </S.NomeSubSessao>
          <S.GridCustomizado orientacao="column" gridTemplateColumns="repeat(2,280px)" gridTemplateRow="1fr" gridGap="72px" margin="0 0 48px 0">
            <div>
              <S.Label>Tipo Muro Externo</S.Label>
              <TextField
                name="tipoMuroExterno"
                data-cy="campoTipoMuroExterno"
                value={dadosMuros.tipoMuroExterno}
                fullWidth
                variant="outlined"
                size="small"
                onChange={camposHandler}
                onBlur={validarTipoMuroExterno}
                error={mensagensErro.tipoMuroExterno != ''}
                helperText={mensagensErro.tipoMuroExterno}
                select
              >
                <MenuItem value={TipoMuroEnum.Frisado} data-cy="tipoMuroExternoFrisado">
                  Frisado
                </MenuItem>
                <MenuItem value={TipoMuroEnum.Rebocado} data-cy="tipoMuroExternoRebocado">
                  Rebocado
                </MenuItem>
                <MenuItem value={TipoMuroEnum.SemMuro} data-cy="tipoMuroExternoSemMuro">
                  Sem Muro
                </MenuItem>
              </TextField>
            </div>
            {dadosMuros.tipoMuroExterno !== '' && dadosMuros.tipoMuroExterno !== TipoMuroEnum.SemMuro && (
              <div>
                <S.Label>Perímetro Externo (m)</S.Label>
                <TextField
                  placeholder="00,00"
                  name="perimetroExterno"
                  data-cy="campoPerimetroExterno"
                  value={dadosMuros.perimetroExterno}
                  onChange={camposHandler}
                  onBlur={validarPerimetroExterno}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
                  }}
                  error={mensagensErro.perimetroExterno != ''}
                  helperText={mensagensErro.perimetroExterno}
                />
              </div>
            )}
          </S.GridCustomizado>
        </S.Wrapper>
      )}
      <S.Wrapper data-cy="sessaoMuroInterno">
        <S.NomeSubSessao>MURO INTERNO</S.NomeSubSessao>
        <S.GridCustomizado orientacao="column" gridTemplateColumns="repeat(2,280px)" gridTemplateRow="1fr" gridGap="72px" margin="0 0 48px 0">
          <div>
            <S.Label>Tipo Muro Interno</S.Label>
            <TextField
              name="tipoMuroInterno"
              data-cy="campoTipoMuroInterno"
              value={dadosMuros.tipoMuroInterno}
              fullWidth
              placeholder="Selecione"
              variant="outlined"
              size="small"
              onChange={camposHandler}
              onBlur={validarTipoMuroInterno}
              error={mensagensErro.tipoMuroInterno != ''}
              helperText={mensagensErro.tipoMuroInterno}
              select
            >
              <MenuItem value={TipoMuroEnum.Frisado} data-cy="tipoMuroInternoFrisado">
                Frisado
              </MenuItem>
              <MenuItem value={TipoMuroEnum.Rebocado} data-cy="tipoMuroInternoRebocado">
                Rebocado
              </MenuItem>
              <MenuItem value={TipoMuroEnum.SemMuro} data-cy="tipoMuroInternoSemMuro">
                Sem Muro
              </MenuItem>
            </TextField>
          </div>
        </S.GridCustomizado>
      </S.Wrapper>
    </S.Wrapper>
  )
}

export default Muros
